export interface ILanguage {
  country: string
  name: string
  originalName: string
  iconSrc: string
  iconRect?: string
  locale: string
  href?: string
}

const languages: ILanguage[] = [
  {
    country: 'United Kingdom',
    originalName: 'English',
    name: 'English',
    iconSrc: '/images/flags/uk.svg',
    iconRect: '/images/flags/rect/uk.svg',
    locale: 'en',
    href: 'https://binany.com',
  },
  {
    country: 'India',
    originalName: 'Hindi',
    name: 'Hindi',
    iconSrc: '/images/flags/india.svg',
    iconRect: '/images/flags/rect/india.svg',
    locale: 'hi',
    href: 'https://binany.com/hi',
  },
  {
    country: 'Bangladesh',
    originalName: 'বাংলা (India)',
    name: 'Bengali',
    iconSrc: '/images/flags/bangladesh.svg',
    iconRect: '/images/flags/rect/bangladesh.svg',
    locale: 'bn',
    href: 'https://binany.com/bn',
  },
  {
    country: 'Indonesia',
    originalName: 'Indonesia',
    name: 'Indonesian',
    iconRect: '/images/flags/rect/indonesia.svg',
    iconSrc: '/images/flags/indonesia.svg',
    locale: 'id',
    href: 'https://binany.com/id',
  },
  {
    country: 'Malaysia',
    originalName: 'Malaysia',
    name: 'Malay',
    iconRect: '/images/flags/rect/malaysia.svg',
    iconSrc: '/images/flags/malaysia.svg',
    locale: 'ms',
    href: 'https://binany.com/ms',
  },
  {
    country: 'Myanmar',
    originalName: `Myanmar`,
    name: 'Myanmar',
    iconRect: '/images/flags/rect/myanmar.svg',
    iconSrc: '/images/flags/myanmar.svg',
    locale: 'my',
    href: 'https://binany.com/my',
  },
  {
    country: 'Ethiopia',
    originalName: `አማርኛ`,
    name: 'Amharic',
    iconRect: '/images/flags/rect/ethiopia.svg',
    iconSrc: '/images/flags/ethiopia.svg',
    locale: 'am',
    href: 'https://binany.com/am',
  },
  {
    country: 'Pakistan',
    originalName: `ਪੰਜਾਬੀ`,
    name: 'Punjabi',
    iconRect: '/images/flags/rect/pakistan.svg',
    iconSrc: '/images/flags/pakistan.svg',
    locale: 'pa',
    href: 'https://binany.com/pa',
  },
  {
    country: 'Sri Lanka',
    originalName: `සිංහල`,
    name: 'Sinhalese',
    iconRect: '/images/flags/rect/sri-lanka.svg',
    iconSrc: '/images/flags/sri-lanka.svg',
    locale: 'si',
    href: 'https://binany.com/si',
  },
  {
    country: 'Kenya',
    originalName: `Kiswahili`,
    name: 'Swahili',
    iconRect: '/images/flags/rect/kenya.svg',
    iconSrc: '/images/flags/kenya.svg',
    locale: 'sw',
    href: 'https://binany.com/sw',
  },
  {
    country: 'Vietnam',
    originalName: `Tiếng Việt`,
    name: 'Vietnamese',
    iconRect: '/images/flags/rect/vietnam.svg',
    iconSrc: '/images/flags/vietnam.svg',
    locale: 'vi',
    href: 'https://binany.com/vi',
  },
  {
    country: 'Nigeria',
    originalName: `Hausa`,
    name: 'Hausa',
    iconRect: '/images/flags/rect/nigeria.svg',
    iconSrc: '/images/flags/nigeria.svg',
    locale: 'ha',
    href: 'https://binany.com/ha',
  },
  {
    country: 'Saudi Arabia',
    originalName: `العربية`,
    name: 'Arabic',
    iconRect: '/images/flags/rect/saudi-arabia.svg',
    iconSrc: '/images/flags/saudi-arabia.svg',
    locale: 'ar',
    href: 'https://binany.com/ar',
  },
  {
    country: 'Portugal',
    originalName: 'Português',
    name: 'Portuguese',
    iconSrc: '/images/flags/portugal.svg',
    locale: 'pt',
    href: 'https://binany.com/pt',
  },
  {
    country: 'Brazil',
    originalName: `Português (Brasil)`,
    name: 'Portuguese (Brasil)',
    iconRect: '/images/flags/rect/brazil.svg',
    iconSrc: '/images/flags/brazil.svg',
    locale: 'pt-BR',
    href: 'https://binany.com/pt-BR',
  },
  {
    country: 'Thailand',
    originalName: 'ไทย',
    name: 'Thai',
    iconSrc: '/images/flags/thailand.svg',
    locale: 'th',
    href: 'https://binany.com/th',
  },
  {
    country: 'Spain',
    originalName: 'Español',
    name: 'Spanish',
    iconSrc: '/images/flags/spain.svg',
    locale: 'es',
    href: 'https://binany.com/es',
  },
  {
    country: 'United Kingdom',
    originalName: 'English(Bangladesh)',
    name: 'English',
    iconSrc: '/images/flags/uk.svg',
    iconRect: '/images/flags/rect/uk.svg',
    locale: 'en-BD',
    href: 'https://binany24.com/en-BD',
  },
  {
    country: 'Bangladesh',
    originalName: 'বাংলাদেশ (Bangladesh)',
    name: 'Bengali',
    iconSrc: '/images/flags/bangladesh.svg',
    iconRect: '/images/flags/rect/bangladesh.svg',
    locale: 'bn-BD',
    href: 'https://binany24.com',
  },
]

export const whiteList = [
  'en',
  'hi',
  'bn',
  'id',
  'ms',
  'my',
  'am',
  'pa',
  'si',
  'sw',
  'vi',
  'ha',
  'ar',
  'pt',
  'pt-BR',
  'th',
  'es',
]

export const whiteListBD = ['bn-BD', 'en-BD']

export default languages
